// extracted by mini-css-extract-plugin
export default {"chartColors":"[#ff6384,#36a2eb,#ffce56,#4bc0c0,#96f,#ff9f40]"};